import React from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { EventAddContainer } from './EventAdd.Container';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AttachmentIcon from '@mui/icons-material/Attachment';
import * as R from 'ramda';
import { Comment } from '../Common/Comment';
import { ChangeHistory } from '../Common/ChangeHistory';
import IconButton from '@mui/material/IconButton';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DialogBoxMedium } from '../../common/dialog.medium';
import * as _cs from '../../common/common';
import 'date-fns';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import { CustomDatePicker } from '../../common/CustomDatePicker';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { CustomizedSnackbars } from '../../common/snackbars';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import parse from 'html-react-parser';

const API_URL = process.env.REACT_APP_API_URL;
const StyledHistory = styled('div')(({ theme }) => ({
    '& .root': {
        width: '100%',
    },
}));
const DialogContent = (props) => {
    return (
        <form className="form-fullwidth" onSubmit={props.OnSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                    <FormControl>
                        <TextField
                            id="comment"
                            name="comment"
                            label={(props.FormProps.Action === 'approve') ? "Comments (optional)" : "Comments"}
                            type="text"
                            required={(props.FormProps.Action === 'unapprove') ? true : false}
                            multiline={true}
                            variant="outlined"
                            value={(typeof props.FormProps.FormFields.comment !== 'undefined') ? props.FormProps.FormFields.comment : null}
                            onChange={props.FormProps.HandleCommentChange}
                            error={typeof props.FormProps.Errors != 'undefined' && props.FormProps.Errors.comment}
                            helperText={typeof props.FormProps.Errors != 'undefined' && props.FormProps.Errors.comment}
                        />
                    </ FormControl>
                </Grid>
            </Grid>
        </form>
    )
}
export const EventViewComponent = (props) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    let image_url = API_URL + 'api/request/timeoff/download?id=' + (R.type(props.Request.request) !== 'Undefined' ? props.Request.request.attachment_id : []);
    let height = props.Height + 25 + 'px';
    let related_requests = props?.Request?.related_requests? Object.values(props.Request.related_requests): [];
    return (
        <React.Fragment>
            <div className="section-main section-main-header-fixed">
                <div className={'header-fixed'}>
                    <div className="section-header">
                        <div className="col-left">
                            <Button size="small" variant="outlined" className="startIcon-noMargin" startIcon={<Tooltip title="Back" aria-label="back"><ChevronLeftIcon /></Tooltip>} onClick={() => { window.history.back(); }} ></Button>
                            <div className="section-title-wrap">
                                <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">
                                    Event Request Details
                                </Typography>
                                {R.type(props.Request.request) !== 'Undefined' &&
                                    <Typography>ID: {props.Request.request.id}</Typography>
                                }
                            </div>
                        </div>
                        <div className={'action'}>
                            {props.IsEdit && (props.IsEventTimeoff == false) &&
                                <span>
                                    <Button variant="contained" color="primary" size="small" onClick={() => props.EventEdit(props.EditId)}>
                                        Edit
                                    </Button>
                                </span>
                            } <i> </i>
                            {( (R.type(props.Request.request) !== 'Undefined' && props.Request.request.preliminary_approval == 1) && props.EventDetails.status == 1 && props.IsPrelimReviewer && (props.IsEventTimeoff == false)) ?
                                 <>
                                    <span>
                                        <Button variant="contained" color="primary" size="small" onClick={() => props.PreliminaryApprove(props.EditId)}>
                                        Initial Approval
                                        </Button>
                                    </span>
                                    <i> </i>
                                </>
                            :
                             <></>
                            }
                            {((props.EventDetails.status == 1 || props.EventDetails.status == 5) && props.IsReviewer && (props.IsEventTimeoff == false)) ?
                                <>
                                    <span>
                                        <Button variant="contained" color="primary" size="small" onClick={() => props.EventApprove(props.EditId)}>
                                            Approve
                                        </Button>
                                    </span> <i> </i>
                                    <span>
                                        <Button variant="contained" color="primary" size="small" onClick={() => props.EventReject(props.EditId)}>
                                            Reject
                                        </Button>
                                    </span>
                                </>
                                :
                                <></>
                            }
                            {(props.EventDetails.status == 2 && props.IsReviewer && (props.IsEventTimeoff == false)) ?
                                <span>
                                    <Button variant="contained" color="primary" size="small" onClick={() => props.EventUnApprove(props.EditId)}>
                                        UnApprove
                                    </Button>
                                </span>
                                :
                                <> </>
                            }<i> </i>
                            {(props.Request.is_cancel !== false && (props.IsEventTimeoff == false)) &&
                                <Button variant="outlined" size="small" color="primary" onClick={() => props.AddCommentClick("cancel")}>Cancel</Button>
                            }<i> </i>

                            {(props.Request.comment !== false) &&
                                <Button variant="outlined" size="small" onClick={() => props.AddCommentClick('addcomment')}>Comment</Button>
                            }<i> </i>
                        </div>
                    </div>
                </div>
                <div className="section-body" style={{ top: height }}>
                    <Paper>
                        <div className="timesheet_list-summary">
                            <div className="p-1rem summary box-details">
                                <ul className="list-standard list-ul-shrink">
                                    <li className="list-item">
                                        <label>Staff Name</label>
                                        {R.type(props.Request) !== 'Undefined' && R.type(props.Request.request) !== 'Undefined' &&
                                            <span className="value" class='worklocationLabel'>
                                                <a className={'item-link'} onClick={()=>props.ViewStaffDetails(props.Request.request.user_ids)}>
                                                    {props.Request.request.creator}
                                                </a>
                                            </span>
                                        }
                                    </li>
                                    <li className="list-item">
                                        <label>Request For</label>
                                        {R.type(props.Request.request) !== 'Undefined' &&
                                            <span className="value">{props.Request.request.to_type}</span>
                                        }
                                    </li>
                                    <li className="list-item">
                                        <label>Event Date</label>
                                        {R.type(props.Request.request) !== 'Undefined' && (props.Request.request.event_date) &&
                                            <span className="value">{props.Request.request.event_date}</span>
                                        }
                                    </li>
                                    <li className="list-item">
                                        <label>Eligibility Period</label>
                                        {R.type(props.Request.request) !== 'Undefined' && (props.Request.request.start_date && props.Request.request.end_date) &&
                                            <span className="value">{props.Request.request.r_sdate} - {props.Request.request.r_edate}</span>
                                        }
                                    </li>
                                    <li className="list-item">
                                        <label>Status</label>
                                        {R.type(props.Request.request) !== 'Undefined' &&
                                            <span className="value" class='worklocationLabel'>{props.Request.request.request_status_name}</span>
                                        }
                                    </li>

                                    {R.type(props.Request.request) !== 'Undefined' && props.Request.request.attachment_id &&
                                        <li className="list-item">
                                            <label><AttachmentIcon /></label>
                                            <a href={image_url} > {_cs.formatFileName(props.Request.request.name, 19)} </a>
                                        </li>
                                    }
                                </ul>
                                <ul className="list-standard list-ul-grow list-ul-border-l">
                                {R.type(props.Request.request) !== 'Undefined' && props.Request.request.type &&
                                    <li className="list-item list-item-block">
                                        <label>Event Type</label>
                                            <span className="value">{props.Request.request.type}</span>
                                    </li>
                                }
                                    {R.type(props.Request.recipients) !== 'Undefined' && (props.Request.recipients != null) &&
                                        <li className="list-item list-item-block">
                                            <label>Email Recipients </label>
                                            <span className="value">
                                                {R.type(props.Request.recipients) !== 'Undefined' && (props.Request.recipients != null) && Object.keys(props.Request.recipients).map((ry, i) =>
                                                    <><span className="pill">{props.Request.recipients[ry].user_fullname}{props.Request.recipients[ry].rev}</span></>

                                                )}
                                            </span>
                                        </li>
                                    }
                                    <li className="list-item list-item-bottom-info">
                                        <div>
                                            <i><strong>Submitted by: </strong></i>
                                            {R.type(props.Request.request) !== 'Undefined' &&
                                                <i>{props.Request.request.creator}</i>
                                            }
                                            {R.type(props.Request.request) !== 'Undefined' &&
                                                <i> on {props.Request.request.created_on} </i>
                                            }
                                            {(props.Request.request) && R.type(props.Request.request.modifier) !== 'Undefined' && (props.Request.request.modifier) &&
                                                <>
                                                    |
                                                    <i><strong> Modified by: </strong></i>
                                                    <i>{props.Request.request.modifier}</i>
                                                    <i> on {props.Request.request.updated_on} </i>
                                                </>
                                            }

                                            {(props.Request.request) && R.type(props.Request.request.approver_name) !== 'Undefined' && (props.Request.request.approver_name) &&
                                                <>
                                                    |
                                                    <i><strong> Reviewed by: </strong></i>
                                                    <i>{props.Request.request.approver_name}</i>
                                                    <i> on {props.Request.request.reviewed_on} </i>
                                                </>
                                            }
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Paper>
                    <Paper>
                    <StyledHistory>
                            <div className={'root'}>
                                <Comment Comments={R.type(props.CommentsHistory) !== 'Undefined' ? props.CommentsHistory : []} />
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography className={'heading'}>Related Time Off Requests</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {related_requests.length > 0 ?
                                    <Table  size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Task</TableCell>
                                                <TableCell>Requested Hours</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {(related_requests).map((item) => 
                                            <TableRow key = {item.id}>
                                                <TableCell component="th" scope="row"> {item.rdate} </TableCell>
                                                <TableCell component="th" scope="row"> {item.task_name} </TableCell>
                                                <TableCell component="th" scope="row"> {item.hours}</TableCell>
                                                <TableCell component="th" scope="row"> {item.request_status_name} </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <Tooltip title="View" aria-label="view">
                                                        <IconButton  className={'action-btn'} edge="end" aria-label="Comments">
                                                            <VisibilityIcon fontSize="small" onClick={()=>props.ViewRelatedTimeoff(item.request_id)}/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        </TableBody>
                                    </Table>
                                    :
                                    <Typography variant="body2" gutterBottom align='center'>No related time off requests.</Typography>
                                }
                            </AccordionDetails>
                        </Accordion>
                            <ChangeHistory History={R.type(props.ChangeLog) !== 'Undefined' ? props.ChangeLog : []} />
                            </div>
                        </StyledHistory>
                    </Paper>
                </div>
                {(props.Popup === 'edit' && props.Open) &&
                    <EventAddContainer
                        OpenAdd={props.Open}
                        EditId={props.EditId}
                        Title={"EDIT"}
                        OnClose={props.OnClose}
                        OnSuccess={props.OnSuccess}
                        OnParentUpdate={props.OnParentUpdate}
                    />
                }
                <DialogBoxMedium
                    Open={props.ApproveOpen}
                    Cancel={props.OnClose}
                    ButtonName= {'Approve'}
                    OnSubmit={props.PrelimApprove ? ()=> props.ReviewRequest('prelim') : () => props.ReviewRequest('approve')}
                    Title={props.PrelimApprove ? 'Initial Approval': 'Final Approval'}
                    Disabled={props.ButtonDisabled}
                    Content={ props.PrelimApprove ?  
                       <DialogPreliminaryApproveEvent  FormProps={props} />
                        : <DialogApproveEvent FormProps={props} /> 
                    }
                />
                <DialogBoxMedium
                    Open={props.CommentOpen}
                    Cancel={props.OnClose}
                    Title={props.Action === 'addcomment' ? 'Add Comment' : 'Cancel Request'}
                    ButtonName={props.Action === 'addcomment' ? 'Add' : 'Yes'}
                    OnSubmit={props.HandleSubmit}
                    Loading={props.Loading}
                    Disabled={props.ButtonDisabled}
                    Content={<DialogContent FormProps={props} />}
                />
                <DialogBoxMedium
                    Open={props.UnApproveOpen}
                    Cancel={props.OnClose}
                    ButtonName='UnApprove'
                    Disabled={props.ButtonDisabled}
                    OnSubmit={() => props.ReviewRequest('unApprove')}
                    Title={'UnApprove Request'}
                    Content={
                        <DialogUnApproveEvent FormProps={props} />
                    }
                />
                <DialogBoxMedium
                    Open={props.RejectOpen}
                    Cancel={props.OnClose}
                    ButtonName='Reject'
                    Disabled={props.ButtonDisabled}
                    OnSubmit={() => props.ReviewRequest('reject')}
                    Title={'Reject Request'}
                    Content={
                        <DialogRejectEvent FormProps={props} />
                    }
                />
                {props.SnackbarOpen &&
                    <CustomizedSnackbars
                        open={props.SnackbarOpen}
                        variant={props.SnackbarVariant}
                        message={props.SnackbarMsg}
                        handleClose={props.SnackbarClose}
                    />
                }
                </div>
        </React.Fragment>
    )
}
    
const DialogPreliminaryApproveEvent = (props) => {
    return (
        <form className="form-fullwidth" >
            <div>
                <Box className={'mt-1'}>
                    <Typography variant="subtitle2" gutterBottom>
                        Charge code will not be added until Final Approval is granted. Employees may update and resubmit later.
                    </Typography>
                </Box>
                <Box className={'mt-1'}>
                    <TextField
                        id="comment"
                        name="comment"
                        label="Comments"
                        multiline
                        variant="outlined"
                        fullWidth
                        onChange={props.FormProps.HandleOnChange}
                        error={props.FormProps.ValidationErrors.comment && true}
                        helperText={props.FormProps.ValidationErrors.comment}
                    />
                </Box>
            </div>
        </form>
    )
}

const DialogUnApproveEvent = (props) => {
    return (
        <form className="form-fullwidth" >
            <div>
                <Box className={'mt-1'}>
                    <Typography variant="subtitle2" gutterBottom>
                        Do you want to unapprove request(s)?
                    </Typography>
                </Box>
                <Box className={'mt-1'}>
                    <TextField
                        id="comment"
                        name="comment"
                        label="Comments"
                        multiline
                        required
                        variant="outlined"
                        fullWidth
                        onChange={props.FormProps.HandleOnChange}
                        error={props.FormProps.ValidationErrors.comment && true}
                        helperText={props.FormProps.ValidationErrors.comment}
                    />
                </Box>
            </div>
        </form>
    )
}

const DialogRejectEvent = (props) => {
    return (
        <form className="form-fullwidth" >
            <div>
                <Box className={'mt-1'}>
                    <Typography variant="subtitle2" gutterBottom>
                        Do you want to reject request(s)?
                    </Typography>
                </Box>
                <Box className={'mt-1'}>
                    <TextField
                        id="comment"
                        name="comment"
                        label="Comments"
                        multiline
                        required
                        variant="outlined"
                        fullWidth
                        onChange={props.FormProps.HandleOnChange}
                        error={props.FormProps.ValidationErrors.comment && true}
                        helperText={props.FormProps.ValidationErrors.comment}
                    />
                </Box>
            </div>
        </form>
    )
}

const DialogApproveEvent = (props) => {
    if (props.FormProps.ErrorsArray && props.FormProps.ErrorsArray.length > 0) {
        let element = document.getElementById('errorMsg');  
        if (element) {
            element.scrollIntoView(true);     
        }
    }        
    return (
        <form className="form-fullwidth" >
            <Grid container spacing={2} >
                <Grid item xs={12} md={12} id="errorMsg">
                    {( props.FormProps.ErrorsArray && props.FormProps.ErrorsArray.length > 0) &&
                        <>
                            {props.FormProps.ErrorsArray.map((er, i) =>
                                <><span className={'error'}>{parse(er)}</span><br/><br/></>
                            )}
                        </>
                    }
                </Grid>
                <Grid item xs={12} md={12} >
                    Please confirm the following details
                </Grid>
                <Grid item md={12} xs={12}>
                    <FormControl variant='standard'>
                        <InputLabel htmlFor="timeoffTask" required > Request For </InputLabel>
                        <Select
                            value={(typeof props.FormProps.FormValues.timeoffTask !== 'undefined') ? props.FormProps.FormValues.timeoffTask : ""}
                            onChange={props.FormProps.HandleOnChange}
                            inputProps={{
                                name: 'timeoffTask',
                                id: 'timeoffTask',
                            }}
                        >
                            {typeof props.FormProps.TimeoffTasks !== 'undefined' && props.FormProps.TimeoffTasks.map((tt, i) =>
                                <MenuItem value={tt.id} >{tt.to_type}</MenuItem>
                            )}
                        </Select>
                        <small className='error'>{props.FormProps.ValidationErrors.timeoffTask}</small>
                    </ FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl>
                        <CustomDatePicker
                            id="startDate"
                            name="startDate"
                            selectedDate={props.FormProps.FormValues.startDate}
                            handleDateChange={props.FormProps.HandleDateChange}
                            required={true}
                            label={'Eligibility Start Date'}
                            minDate={props.FormProps.DOJ}
                            maxDate={props.FormProps.RelievedDate}
                        />
                        <small className='error'>{props.FormProps.ValidationErrors.startDate}</small>
                    </ FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl>
                        <CustomDatePicker
                            id="endDate"
                            name="endDate"
                            selectedDate={props.FormProps.FormValues.endDate}
                            handleDateChange={props.FormProps.HandleDateChange}
                            label={'Eligibility End Date'}
                            minDate={props.FormProps.DOJ}
                            maxDate={props.FormProps.RelievedDate}
                        />
                        <small className='error'>{props.FormProps.ValidationErrors.endDate}</small>
                    </FormControl>
                </Grid>
            </Grid>
        </form>
    )
};
